const Add_to_cart = "Add_to_cart";
const Remove_from_cart = "Remove_from_cart";
const Update_cart = "Update_cart";
const Clear_cart = "Clear_cart";


export { Add_to_cart, Remove_from_cart, Update_cart, Clear_cart}